<template>
  <div class="detail-page">
    <BreadCrumb :data="breadcrumb" :title="'富文本管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <div class="search-tags">
      <p
        class="search-tag"
        :class="item == selectedTag ? 'active' : ''"
        v-for="item in titles"
        :key="item.id"
        @click="changeTag(item)"
      >
        {{ item.slice(7) }}
      </p>
    </div>
    <EditContent
      v-if="selectedTag == 'guihua-Introduction'"
      ref="worksContent"
      :position="'guihua-Introduction'"
      :content="RichTextDetail.content"
      :isEditting="isEditting"
    ></EditContent>
    <EditContent
      v-if="selectedTag == 'guihua-chief'"
      ref="worksContent"
      :position="'guihua-chief'"
      :content="RichTextDetail.content"
      :isEditting="isEditting"
    ></EditContent>
    <EditContent
      v-if="selectedTag == 'guihua-email'"
      ref="worksContent"
      :position="'guihua-email'"
      :content="RichTextDetail.content"
      :isEditting="isEditting"
    ></EditContent>
    <EditContent
      v-if="selectedTag == 'guihua-notice'"
      ref="worksContent"
      :position="'guihua-notice'"
      :content="RichTextDetail.content"
      :isEditting="isEditting"
    ></EditContent>
    <EditContent
      v-if="selectedTag == 'guihua-editorial'"
      ref="worksContent"
      :position="'guihua-editorial'"
      :content="RichTextDetail.content"
      :isEditting="isEditting"
    ></EditContent>
    <EditContent
      v-if="selectedTag == 'guihua-editorial-h5'"
      ref="worksContent"
      :position="'guihua-editorial-h5'"
      :content="RichTextDetail.content"
      :isEditting="isEditting"
    ></EditContent>

    <El-button v-if="isEditting" @click="save()" class="edit-btn"
      >保存</El-button
    >
  </div>
</template>
<script>
import BannerManage from "../../../componentSet/BannerCarousel.vue";
import BreadCrumb from "../../../componentSet/BreadCrumb";
import EditContent from "../../../componentSet/EditContent2.vue";
import {
  updateMagazineRichText_Api,
  MagazineRichText_Api,
} from "../../../../../src/apis/magazine.api";
import SaveGroup from "../../../componentSet/SaveGroup.vue";
export default {
  data() {
    return {
      isEditting: false,
      selectedTag: "guihua-Introduction",
      titles: [
        "guihua-Introduction",
        "guihua-chief",
        "guihua-email",
        "guihua-notice",
        "guihua-editorial",
        "guihua-editorial-h5",
      ],
      RichTextDetail: {
        content: "",
        text_id: null,
      },
    };
  },
  components: {
    EditContent,
    SaveGroup,
    BreadCrumb,
    BannerManage,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "文本管理", link: "/admin/magazineRichText" },
      ];
    },
  },
  mounted() {
    this.getMagazineRichTextDetail();
  },
  methods: {
    getMagazineRichTextDetail() {
      MagazineRichText_Api(this.selectedTag).then((res) => {
        this.RichTextDetail = res.data;
        this.RichTextDetail.text_id = this.RichTextDetail.id;
        console.log(res);
      });
    },
    changeTag(item) {
      this.selectedTag = item;
      this.getMagazineRichTextDetail(item);
    },
    edit() {
      this.isEditting = true;
    },
    save() {
      let formattedData = this.validateForm(this.RichTextDetail);
      if (!formattedData) {
        return;
      } else {
        updateMagazineRichText_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getMagazineRichTextDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
      this.isEditting = false;
    },
    validateForm(formData) {
      //表单校验
      formData.content = this.$refs.worksContent.getContent();
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.search-tags {
  display: flex;
  margin-top: 20px;
  border-bottom: 2px solid $indexHotLine;
  margin-bottom: 33px;
  .search-tag {
    font-size: 20px;
    line-height: 40px;
    font-weight: bold;
    margin-right: 50px;
    cursor: pointer;
  }
  .active {
    color: $timeBtn;
    border-bottom: 6px solid $timeBtn;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/guihua/components/magazineRichText.vue